import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWhiteboard1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconWhiteboard1"><Path d="M16 18.25H18.25C19.9069 18.25 21.25 16.9069 21.25 15.25V7.75C21.25 6.09315 19.9069 4.75 18.25 4.75H12M16 18.25L17 21.25M16 18.25H12M8 18.25H5.75C4.09315 18.25 2.75 16.9069 2.75 15.25V7.75C2.75 6.09315 4.09315 4.75 5.75 4.75H12M8 18.25L7 21.25M8 18.25H12M12 4.75V2.75M12 18.25V20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconWhiteboard1;
